<template>
  <div id="app">
    <router-view />
    <div class="footer-container">
      <p>
        {{ name }} -
        <a :href="mail" target="_blank">{{ mail_name }}</a>&nbsp;- References on request
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data () {
    return {
      mail: "U2FsdGVkX18WwQovJyB/ySkTxECBvcKl1pWKKFwfSz9iLgcTTAnvchSPxlBdfd63",
      mail_name: "U2FsdGVkX1/CsRSHAW01yS423OBrgzQBmT1pRQnwbr/eLlomxXqlAUwxBQmHo4vW",
      name: "U2FsdGVkX197nsNCqoaQI9eClnzNrPszLdAYJJRyW0s="
    }
  },
  mounted () {
    ["mail", "mail_name", "name"].forEach(n=>this[n] = this.mStore.decode(this[n]))
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 15px;
}
.footer-container {
  margin-top: 100px;
}
.footer-container p {
  text-align: center;
  font-style: italic;
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/App.vue